module.exports = __webpack_public_path__ + "img/collegues-third.81824707.png";